// extracted by mini-css-extract-plugin
export var closeButton = "_31-3";
export var header = "_31-0";
export var link = "_31-1";
export var retryButton = "_31-2";